import { PercentPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

	/**
	 * @description
	 *	Transforma un número aplicando el formato de porcentaje. En
	 *	particular, muestra su valor usando 2 decimales por defecto, pero la
	 *	cantidad de decimales es personalizable. Este pipe reemplaza al que
	 *	provee Angular, denominado PercentPipe.
	 */

@Pipe({ name: "percentage", pure: true })
export class PercentagePipe implements PipeTransform {

	public constructor(private percentPipe: PercentPipe) {}

	/**
	 * @description
	 *	Transforma un número en su representación porcentual.
	 *
	 * @param value
	 *	El número, posiblemente sin especificar.
	 * @param decimals
	 *	La cantidad de decimales fijos a mostrar, por defecto igual que 2.
	 * @param orElse
	 *	Resultado a devolver si el número no fue especificado.
	 *
	 * @returns
	 *	La representación porcentual del número, o la cadena indicada en el
	 *	parámetro 'orElse', si el número es 'null', 'undefined' o NaN (Not a
	 *	Number).
	 */
	public transform(value: number, decimals: number = 2, orElse: string = "[no disponible]"): string {
		if (value === null || value === undefined || Number.isNaN(value)) {
			return orElse;
		}
		else {
			return this.percentPipe.transform(value / 100.0, `1.${decimals}-${decimals}`)
				.replace(/\./g, "_")
				.replace(/,/g, ".")
				.replace(/_/g, ",")
				.replace("%", " %");
		}
	}
}
